import React from "react";

// Tick Icon for success items
export const TickIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.70285 13.0419L6.2409 9.5817L7.39216 8.43101L9.70285 10.7405L16.0389 4.48931L17.1983 5.63999L9.71101 13.0419H9.70285Z"
      fill="#008253"
    />
    <path
      d="M16.2399 8.93699C16.2808 9.22262 16.3053 9.50825 16.3053 9.80204C16.3053 13.3928 13.3904 16.3063 9.79778 16.3063C6.20519 16.3063 3.2903 13.3928 3.2903 9.80204C3.2903 6.21125 6.20519 3.29782 9.79778 3.29782C11.194 3.29782 12.4841 3.7385 13.5455 4.48931L14.7294 3.30598C13.3577 2.26138 11.6512 1.633 9.79778 1.633C5.29072 1.64116 1.63281 5.29723 1.63281 9.80204C1.63281 14.3069 5.29072 17.9629 9.79778 17.9629C14.3048 17.9629 17.9627 14.3069 17.9627 9.80204C17.9627 9.0186 17.8484 8.25963 17.6361 7.54148L16.2399 8.93699Z"
      fill="#008253"
    />
  </svg>
);

export default TickIcon;
